import React from 'react';
import { NextPage } from 'next';
import { CacheControlHeaders } from 'constants/Global';
import { reduxWrapper } from 'store';
import { QuizCardTileList } from 'styled';
import { QUIZ_PAGE_SIZE } from 'lib/constants';
import useLanguage from 'hooks/useLanguage';
import { fetchQuizzes, sxQuizPageHero, validateQueryParams } from '../utils';
import { type Quiz as IQuiz, QuizType } from 'types';

interface Props {
  count: number;
  pageNumber: number;
  quizzes: IQuiz[];
  slug: string;
}

const SymptomQuizPage: NextPage<Props> = ({
  count,
  pageNumber,
  quizzes,
  slug,
}: Props) => {
  const language = useLanguage();
  const totalPages = Math.ceil(count / QUIZ_PAGE_SIZE);

  return (
    <QuizCardTileList
      quizzes={quizzes}
      totalPages={totalPages}
      pageNumber={pageNumber}
      slug={slug}
      shouldPaginate={true}
      pageHero={sxQuizPageHero(language)}
      pageTitle={language.t('Quiz.sxBrowse.pageTitle')}
    />
  );
};

export const getServerSideProps = reduxWrapper.getServerSideProps(
  async ({ query, res }) => {
    res.setHeader('Cache-Control', CacheControlHeaders.NO_CACHE);

    try {
      const queryParams = validateQueryParams(query);

      const result = await fetchQuizzes({
        type: QuizType.Sx,
        limit: QUIZ_PAGE_SIZE,
        pageNumber: queryParams.page,
        titleStartsWith: queryParams.search,
      });

      if (!result.quizzes) {
        return { notFound: true };
      }

      return {
        props: {
          count: result.count,
          pageNumber: queryParams.page,
          quizzes: result.quizzes,
          slug: '/symptom-quiz',
        },
      };
    } catch (err) {
      return {
        notFound: true,
      };
    }
  },
);

export default reduxWrapper.withRedux(SymptomQuizPage);
